module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/faceWash@2x_83f5ed.png";